import { combineReducers } from 'redux';
import accountUsageReducer from './accountUsageSlice';
import appVersionReducer from './appVersionSlice';
import authReducer from './authSlice';
import balanceReducer from './balanceSlice';
import blotterReducer from './blotterSlice';
import celerMarketReducer from './celerMarketSlice';
import chartDataReducer from './chartDataSlice';
import generalReducer from './generalSlice';
import languageReducer from './languageSlice';
import liteMarketReducer from './liteMarketSlice';
import marketPairReducer from './marketPairSlice';
import mosaicReducer from './mosaicSlice';
import nopPositionReducer from './nopPositionSlice';
import notificationsReducer from './notificationSlice';
import ohoReducer from './ohoSlice';
import openPositionReducer from './openPositionSlice';
import orderReducer from './orderSlice';
import portalPlatformReducer from './portalPlatformSlice';
import settingReducer from './settingSlice';
import tableSettingReducer from './tableSettingSlice';
import themeReducer from './themeSlice';
import tickerReducer from './tickerSlice';
import traderMarketReducer from './traderMarketSlice';
import workspaceReducer from './workspaceSlice';

export default combineReducers({
    accountUsage: accountUsageReducer,
    appVersion: appVersionReducer,
    auth: authReducer,
    balance: balanceReducer,
    blotter: blotterReducer,
    celerMarket: celerMarketReducer,
    chartData: chartDataReducer,
    general: generalReducer,
    language: languageReducer,
    liteMarket: liteMarketReducer,
    marketPair: marketPairReducer,
    mosaic: mosaicReducer,
    nopPosition: nopPositionReducer,
    notifications: notificationsReducer,
    oho: ohoReducer,
    openPosition: openPositionReducer,
    order: orderReducer,
    portalPlatform: portalPlatformReducer,
    settings: settingReducer,
    tableSetting: tableSettingReducer,
    theme: themeReducer,
    ticker: tickerReducer,
    traderMarket: traderMarketReducer,
    workspace: workspaceReducer
});
